import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import './PortofolioItemComponent.css';
import portofolioImage from "../../../../assets/images/project/rumah/ANTO_HOUSE/portofolio-ant-house.jpg";

function Portofolio01() {

    const navigate = useNavigate();
    const navigateHome = () => {
        navigate('/detail-project/portofolio-grand-wisata-house');
    };

    return (
        <div className='portofolio-rumah-01' id='id-portofolio-01'>
            <div className="portofolio-rumah-01-container">
                <div className='portofolio-rumah-01-container-img'>
                    <img src={portofolioImage} alt="Rumah industrial 2 lantai" className="portofolio-rumah-01-image" />
                </div>

                <div className="portofolio-rumah-01-overlay" onClick={navigateHome}>
                    <h1>Ant House</h1>
                    <p>Bandung, Jawa Barat</p>
                </div>
            </div>
        </div>
    );
}

export default Portofolio01;